'use strict';

var React = require('react');
var classNames = require('classnames');
var Screen = require('../../utils/Screen.js');
var _ = require('lodash');

var ErrorBar = React.createClass({
    propTypes: {
        errorList: React.PropTypes.array.isRequired
    },
    getInitialState: function() {
        return {
            errorIndex: -1
        };
    },
    getDefaultProps: function () {
        return {
            errorList: []
        };
    },
    goToNextError: function () {
        if (this.props.errorList.length > 0) {
            var errorIndex = this.state.errorIndex;
            errorIndex++;
            if (errorIndex === this.props.errorList.length) {
                errorIndex = 0;
            }
            var currentError = this.props.errorList[errorIndex];
            if (currentError){
                Screen.moveToNextError(currentError.id, true);
            }
            this.setState({errorIndex: errorIndex});
        } 
    },
    componentWillReceiveProps: function(nextProps) {
        if (nextProps.fieldWithErrorId){
            this.setState({errorIndex: _.indexOf(nextProps.errorList, _.find(nextProps.errorList, {className: nextProps.fieldWithErrorId}))});
        }
    },
    shouldComponentUpdate: function(nextProps) {
        return (!_.isEqual(this.props.errorList, nextProps.errorList) || this.props.hideErrorBar !== nextProps.hideErrorBar);
    },
    componentDidUpdate: function(prevProps) {
        if (prevProps.hideErrorBar === true && this.props.hideErrorBar === false){
            var firstError = '';
            if (this.props.errorList.length > 0) {
                firstError = this.props.errorList[0];
                Screen.moveToNextError(firstError.id, true);
            }
            this.setState({errorIndex: 0});
        }
        else {
            this.setState(this.getInitialState());
        }
    },
    render: function () {
        return (
            <nav className={classNames('navbar navbar-error navbar-fixed-top', { hidden: this.props.hideErrorBar})}>
                <div className="container">
                    <div className="pull-left"><h3>{this.props.errorList.length}<span> error(s) to review</span></h3></div>
                    <div className="pull-right"><a className="arrow" onClick={this.goToNextError}><i className="icon icon-down-open-big"></i></a></div>

                </div>
            </nav>
        );
    }
});

module.exports = ErrorBar;



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/ErrorBar.jsx